/* global Swiper */
// *******************************************************************************
// Timeline Slider
// *******************************************************************************

const timelineSliderElements = document.querySelectorAll('[data-slider="timeline-slider"]');

const timelineSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  watchOverflow: true,
  watchSlidesVisibility: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  autoHeight: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  effect: 'fade',
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  fadeEffect: {
    crossFade: true,
  },
  // when window width is >= 1023px
  1023: {
    autoHeight: false,
  },
};

timelineSliderElements.forEach((el) => {
  const timelineSliderParent = el.closest('.timeline-slider');
  const sliderAutoplayDelay = timelineSliderParent.getAttribute('data-swiper-delay');
  const sliderPagination = timelineSliderParent.querySelector('.swiper-pagination');

  const prevButton = timelineSliderParent.querySelector('.swiper-nav__button-prev');
  const nextButton = timelineSliderParent.querySelector('.swiper-nav__button-next');

  timelineSliderOptions.pagination.el = sliderPagination;
  timelineSliderOptions.navigation.prevEl = prevButton;
  timelineSliderOptions.navigation.nextEl = nextButton;

  if (sliderAutoplayDelay) {
    timelineSliderOptions.autoplay = {
      delay: sliderAutoplayDelay,
    };
  }

  const timelineSlider = new Swiper(el, timelineSliderOptions);
});
